<div class="relatorio-dialog-container">
  <div class="dialog-header">
    <h2>{{ data.titulo }}</h2>
    <button class="btn-fechar" (click)="fechar()" title="Fechar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <!-- Renderizar o HTML do relatório, mas apenas o texto formatado -->
    <div class="relatorio-text" [innerHTML]="conteudoSeguro"></div>
  </div>
</div>

